export default "__VITE_ASSET__$HcBAKqJ__"